/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1BannerBanneridLangsIdMutationResponse,
  DeleteApiV1BannerBanneridLangsIdPathParams,
  DeleteApiV1BannerBanneridLangsId401,
  DeleteApiV1BannerBanneridLangsId404,
  DeleteApiV1BannerBanneridLangsId500,
} from "../../types/bannerIdiomasController/DeleteApiV1BannerBanneridLangsId.ts";

function getDeleteApiV1BannerBanneridLangsIdUrl(
  bannerId: DeleteApiV1BannerBanneridLangsIdPathParams["bannerId"],
  id: DeleteApiV1BannerBanneridLangsIdPathParams["id"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/banner/${bannerId}/langs/${id}` as const,
  };
  return res;
}

/**
 * @description Desativa (exclusão lógica) uma tradução (idioma) de banner. **(Requer Authorization para autenticação)**
 * @summary Excluir idioma do banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:bannerId/langs/:id}
 */
export async function deleteApiV1BannerBanneridLangsId(
  bannerId: DeleteApiV1BannerBanneridLangsIdPathParams["bannerId"],
  id: DeleteApiV1BannerBanneridLangsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1BannerBanneridLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1BannerBanneridLangsId401
      | DeleteApiV1BannerBanneridLangsId404
      | DeleteApiV1BannerBanneridLangsId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1BannerBanneridLangsIdUrl(bannerId, id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
